import Project from "./Project";
import SectionTitle from "./SectionTitle";
import { projectImages } from "../assets/narutoImages";

const data = [
  {
    id: 1,
    title: "1TimeMail",
    temp: "Temporary Email Service",
    img1: projectImages.project1.img1,
    img2: projectImages.project1.img2,
    description:
      "A temporary email service that provides users with disposable email addresses for privacy and security. Perfect for signing up to services without revealing your personal email.",
    tools: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "TailwindCSS",
    ],
    liveLink: "https://1timemail.org/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 2,
    title: "PrepWise",
    temp: "AI Interview Prep",
    img1: projectImages.project2.img1,
    img2: projectImages.project2.img2,
    description:
      "An AI-powered interview preparation tool that helps candidates practice and improve their interview skills using advanced natural language processing and machine learning algorithms.",
    tools: [
      "React.js",
      "Python",
      "TensorFlow",
      "NLP",
      "Node.js",
    ],
    liveLink: "https://inter-prep-wise.onrender.com/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 3,
    title: "MediaCraft",
    temp: "AI Image Editor",
    img1: projectImages.project3.img1,
    img2: projectImages.project3.img2,
    description:
      "An intelligent image editing platform powered by AI that provides advanced image manipulation features including background removal, enhancement, and creative filters.",
    tools: [
      "React.js",
      "Python",
      "TensorFlow",
      "Image Processing",
      "AI/ML",
    ],
    liveLink: "https://mediacraft.onrender.com/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 4,
    title: "Voice Chat AI",
    temp: "AI Voice Assistant",
    img1: projectImages.project4.img1,
    img2: projectImages.project4.img2,
    description:
      "An intelligent voice assistant application that uses natural language processing and speech recognition to provide conversational AI experiences for users.",
    tools: [
      "React.js",
      "Python",
      "NLP",
      "Speech Recognition",
      "AI/ML",
    ],
    liveLink: "https://voicechatai.wmart.in/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 5,
    title: "FlexiPDF",
    temp: "PDF Tools",
    img1: projectImages.project5.img1,
    img2: projectImages.project5.img2,
    description:
      "A comprehensive PDF manipulation tool that allows users to merge, split, compress, and convert PDF files with ease. Built with modern web technologies for optimal performance.",
    tools: [
      "React.js",
      "Node.js",
      "Express.js",
      "PDF Processing",
    ],
    liveLink: "https://flexipdf-m7e1.onrender.com/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 6,
    title: "UPI Link Generator",
    temp: "Payment Gateway",
    img1: projectImages.project6.img1,
    img2: projectImages.project6.img2,
    description:
      "A payment gateway tool that generates UPI payment links for seamless transactions. Simplifies the process of creating payment links for businesses and individuals.",
    tools: [
      "React.js",
      "Next.js",
      "Payment Integration",
      "TailwindCSS",
    ],
    liveLink: "https://upilinkgenerator.vercel.app/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 7,
    title: "PatterNix",
    temp: "CSS Pattern Library",
    img1: projectImages.project7.img1,
    img2: projectImages.project7.img2,
    description:
      "A comprehensive CSS pattern library that provides developers with beautiful, customizable patterns and designs. Perfect for adding visual interest to web applications.",
    tools: [
      "React.js",
      "CSS",
      "TailwindCSS",
      "Design System",
    ],
    liveLink: "https://patter-nix.vercel.app/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
  {
    id: 8,
    title: "ImageEditGenie",
    temp: "Background Remover",
    img1: projectImages.project8.img1,
    img2: projectImages.project8.img2,
    description:
      "An AI-powered background removal tool that uses machine learning to accurately remove backgrounds from images. Fast, efficient, and user-friendly.",
    tools: [
      "React.js",
      "Python",
      "AI/ML",
      "Image Processing",
      "TensorFlow",
    ],
    liveLink: "https://erasebg-3m4s.onrender.com/",
    frontEndLink: "https://github.com/Kartikmhatre",
  },
];
const Projects = () => {
  return (
    <div className="projects container mx-auto mt-40" id="projects">
      <SectionTitle title="Projects" />
      <div className="projects-wrapper mt-40 flex flex-col gap-40">
        {data.map((project) => (
          <Project key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
